<template>
  <v-dialog
    v-model="toggleModal"
    width="auto"
    min-width="500"
    scrollable
    persistent
  >
    <v-card>
      <v-card-title class="bg-secondary">
        <div>{{ $t("strings.measure-preview") }}</div>
      </v-card-title>
      <v-card-text v-if="measureResponse.status < 300">
        <div class="d-flex justify-center text-center">
          <span
            class="text-h6 text-medium-emphasis font-weight-regular align-self-center"
          >
            {{ $t("strings.measure-has") }}
          </span>
          <span
            class="mx-2 text-primary text-h5 font-weight-bold align-self-center"
          >
            {{
              measureResponse.data[0] !== undefined
                ? measureResponse.data[0].length
                : 0
            }}
          </span>
          <span
            class="text-h6 text-medium-emphasis font-weight-regular align-self-center"
          >
            {{ $t("strings.values") }}
          </span>
        </div>
        <v-divider class="mt-4 mx-n6"></v-divider>
        <v-expansion-panels elevation="0" :ripple="false" :eager="true">
          <v-expansion-panel>
            <v-expansion-panel-title class="text-overline">
              {{ $t("strings.show-details") }}
            </v-expansion-panel-title>
            <v-expansion-panel-text>
              {{
                measureResponse.data[0] !== undefined
                  ? measureResponse.data[0].toString()
                  : ""
              }}
            </v-expansion-panel-text>
          </v-expansion-panel>
        </v-expansion-panels>
        <v-divider class="mx-n6"></v-divider>
      </v-card-text>
      <v-card-text v-else class="font-weight-medium text-center">
        {{ $t("strings.measure-parameters-alert") }}
        <p class="mt-4 text-caption text-secondary text-left">
          {{ measureResponse.message }}
        </p>
      </v-card-text>
      <div class="text-caption mb-3 d-inline-flex align-center justify-center">
        <v-icon
          color="warning"
          icon="mdi-alert-circle"
          size="large"
          class="me-2"
        ></v-icon>
        <span>{{ (isViewer || isAdmin)? $t("strings.preview-viewer-warning") : $t("strings.preview-warning") }}</span>
      </div>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text="Close" @click="toggleModal = false"></v-btn>
        <v-btn
          v-if="measureResponse.status < 300"
          :disabled="isViewer || isAdmin"
          color="secondary darken-1"
          text
          @click="save()"
        >
          {{ measureId ? $t("labels.update") : $t("labels.save") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ["dialog", "measureResponse", "measureId","isViewer","isAdmin"],
  emits: ["save", "previewDialog"],
  data() {
    return {};
  },
  methods: {
    save() {
      this.$emit("save");
    },
  },
  computed: {
    toggleModal: {
      get() {
        return this.dialog;
      },
      set(val) {
        this.$emit("previewDialog", val);
      },
    },
  },
};
</script>
